import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { AssessmentResult } from '@shared/models';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'assessment-card',
  templateUrl: './assessment-card.component.html',
  styleUrls: ['./assessment-card.component.scss']
})
export class AssessmentCardComponent implements OnInit {
  @Input() assessment: AssessmentResult;
  @Output() showAssessment = new EventEmitter<AssessmentResult>();

  public userName: string;
  public initials: string;
  public score: string;
  public scoreMax: number;
  public chartOption: EChartsOption;

  ngOnInit(): void {
    this.assessment.report.criterias.forEach((c, index) => c.index = index);
    
    const criterias = this.assessment.report.criterias.filter(c => !isNaN(c.grade));
    const total = criterias.reduce((acc, c) => acc + c.grade, 0);
    this.scoreMax = 5;
    this.score = (Math.max(1, total / criterias.length)).toFixed(1);
    this.userName = this.assessment.session.actor_name;
    this.initials = this.userName
      .split(/\s+/)
      .map(s => s.length ? s[0].toUpperCase() : '')
      .join('')
      .substring(0, 2);

    this.setupChart();
  }

  private setupChart() {
    this.chartOption = {
      radar: {
        shape: 'circle',
        axisName: {
          formatter: '{value}',
          color: '#aaa',
          fontSize: 9,
          fontWeight: 'lighter',
          //width: 50,
          overflow: 'truncate'
        },
        splitArea: {
          areaStyle: {
            color: ['rgba(0,0,0,0)'],
          }
        },
        indicator: this.assessment.report.criterias.map(c => {
          return {
            name: `${c.index + 1}`,
            max: 5
          }
        })
      },
      series: [
        {
          type: 'radar',
          color: ['#aaaaaa', '#247e8d'],
          data: [
            {
              value: this.assessment.report.criterias.map(c => c.medianGrade),
              name: 'Group median',
              lineStyle: {
                type: 'dashed'
              }
            },
            {
              value: this.assessment.report.criterias.map(c => c.grade),
              name: 'Learner Score'
            }          
          ]
        }
      ]
    };
  }

  onCardClick() {
    this.showAssessment.emit(this.assessment);
  }
}
